import React from "react";
import { useNavigate } from "react-router";
import { useMediaQuery } from "react-responsive";
import { classifyActiveSessionRoute } from "../../utils";
import { DesktopErrorPage, MobileErrorPage } from "./components";
import { BREAKPOINTS } from "../constants";

const ErrorPage = () => {
    const navigate = useNavigate();
    const route = classifyActiveSessionRoute();
    const isDesktopOrLaptop = useMediaQuery({ query: BREAKPOINTS.DESKTOP })

    const navigateHome = () => {
        navigate(route);
    };

    if (isDesktopOrLaptop) {
        return <DesktopErrorPage navigateHome={navigateHome} />
    }

    return <MobileErrorPage navigateHome={navigateHome} />
};

export default ErrorPage;